module.exports = __webpack_public_path__ + "media/images/home-banners/creek-593146_1920-5684e4a8a43289ff605c002aac816bf8.jpg";